import {Upload} from './upload.model';

export class Page {

    id: number;
    title: string;
    text_content: string;
    url: string;
    modified: string;
    created: string;

    upload: Upload[];

    constructor(id: number, title: string, text_content: string, url: string, modified: string, created: string, upload?: Upload[]) {
        this.id = id;
        this.title = title;
        this.text_content = text_content;
        this.url = url;
        this.modified = modified;
        this.created = created;
        this.upload = upload;
    }
}

export class PageCreate {

    id: number;
    title: string;
    text_content: string;
    url: string;
    created: string;

    constructor(title: string, text_content: string, url: string) {
        this.title = title;
        this.text_content = text_content;
        this.url = url;
    }

}
